/**
 * The Sitebrew mark, the same drawing the homepage puts next to the wordmark
 * (`sitebrew.app`, `a.brand > svg.mark`): two chevrons over two rules — a tag
 * pair above lines of text.
 *
 * Copied path for path rather than re-drawn, and stroked in `currentColor` as
 * it is there, so the colour is decided by whatever it sits in: ink in the
 * header, the accent when a parent says so, the panel colour inside a filled
 * tile. Nothing here picks a palette.
 *
 * `strokeWidth` is a prop because the stroke is in user units of a 64×64 box:
 * drawn smaller than the homepage's 28px it thins out, and a mark inside a
 * 24px tile needs a heavier pen to read at all.
 */
export function BrandMark({
  className,
  strokeWidth = 5,
}: {
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M26 19l-8 9 8 10" />
      <path d="M38 14.5l8 10-8 10" opacity=".55" />
      <path d="M16 44h32" />
      <path d="M22 53h20" />
    </svg>
  );
}
